import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { faCheck as CheckIcon } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ListItemText, Tooltip } from '@mui/material';
import dayjs from 'dayjs';

import AnchorWrapper from '@/components/AnchorWrapper/AnchorWrapper';
import type { VulnerabilityType } from '@/pages/VulnerabilityManagement/VulnerabilityManagement.types';
import {
  cellFormatter,
  exposureIndexFormatter,
  severityFormatter
} from '@/pages/VulnerabilityManagement/VulnerabilityManagement.utils';
import getDateTime from '@/utils/getDateTime.utils';

export const vulnerabilityDescriptionCell = (row: VulnerabilityType) =>
  cellFormatter(row.id, row.description);

export const vulnerabilitySeverityCell = (row: VulnerabilityType) =>
  severityFormatter(row.id || '', row.cvss || 0, row.cvss_level);

export const vulnerabilityPonduranceScoreCell = (row: VulnerabilityType) =>
  exposureIndexFormatter(
    row.vmp_exposure_index || 0,
    row.severity,
    row.id || ''
  );

export const vulnerabilityRemediatedCell = (row: VulnerabilityType) => (
  <div>
    {row.remediated ? <FontAwesomeIcon size="lg" icon={CheckIcon} /> : ''}
  </div>
);

export const vulnerabilityCVECell = (row: VulnerabilityType) =>
  cellFormatter(row.id, row.cve);

export const vulnerabilityNameExploitedCell = (row: VulnerabilityType) => {
  const exploited = row?.exploited ? (
    <FontAwesomeIcon
      size="lg"
      icon={faTriangleExclamation}
      style={{ color: 'var(--mui-palette-warning-main)' }}
    />
  ) : null;
  return (
    <AnchorWrapper
      path="/vulnerability-management/vulnerability-details"
      itemId={row.id}
    >
      {row.name || ''}
      {exploited && (
        <Tooltip title="Exploited">
          <span style={{ marginLeft: '0.5rem' }}>{exploited}</span>
        </Tooltip>
      )}
    </AnchorWrapper>
  );
};

export const vulnerabilityDateRemediatedCell = (row: VulnerabilityType) => {
  if (!row.date_remediated) {
    return null;
  }

  return (
    <ListItemText
      primary={`${dayjs.utc(row.date_remediated).local().fromNow(true)} ago`}
      secondary={getDateTime(row.date_remediated)}
      sx={{ margin: 0 }}
    />
  );
};

export const vulnerabilityTotalAssetsCell = (row: VulnerabilityType) =>
  cellFormatter(row.id, row.asset_count || 0);

export const vulnerabilityAssetNameCell = (row: VulnerabilityType) =>
  cellFormatter(row.id, row.asset?.asset_name);
